class CartRemoveButton extends HTMLElement {
  constructor() {
    super();

    this.addEventListener('click', (event) => {
      event.preventDefault();
      const cartItems = this.closest('cart-items') || this.closest('cart-drawer-items');
      cartItems.updateQuantity(this.dataset.index, 0);
    });
  }
}

customElements.define('cart-remove-button', CartRemoveButton);

class CartItems extends HTMLElement {
  constructor() {
    super();
    
    this.lineItemStatusElement = document.getElementById('shopping-cart-line-item-status') || document.getElementById('CartDrawer-LineItemStatus');

    const debouncedOnChange = debounce((event) => {
      this.onChange(event);
    }, ON_CHANGE_DEBOUNCE_TIMER);

    this.addEventListener('change', debouncedOnChange.bind(this));
  }

  cartUpdateUnsubscriber = undefined;

  connectedCallback() {
    this.cartUpdateUnsubscriber = subscribe(PUB_SUB_EVENTS.cartUpdate, (event) => {
      if (event.source === 'cart-items') {
        return;
      }
      this.onCartUpdate();
    });
  }

  disconnectedCallback() {
    if (this.cartUpdateUnsubscriber) {
      this.cartUpdateUnsubscriber();
    }
  }

  onChange(event) {
    jQuery(".loader-main").show()
   // console.log("======"+document.activeElement.getAttribute('name'));
    this.updateQuantity(event.target.dataset.index, event.target.value, document.activeElement.getAttribute('name'));

        
  }

  onCartUpdate() {
    
    fetch(`${routes.cart_url}?section_id=main-cart-items`)
      .then((response) => response.text())
      .then((responseText) => {
        const html = new DOMParser().parseFromString(responseText, 'text/html');
        const sourceQty = html.querySelector('cart-items');
        
        
        this.innerHTML = sourceQty.innerHTML;
      })
      .catch(e => {
        console.error(e);
      });
  }

  getSectionsToRender() {
    return [
      {
        id: 'main-cart-items',
        section: document.getElementById('main-cart-items').dataset.id,
        selector: '.js-contents'
      },
      {
        id: 'cart-icon-bubble',
        section: 'cart-icon-bubble',
        selector: '.shopify-section'
      },
      {
        id: 'cart-live-region-text',
        section: 'cart-live-region-text',
        selector: '.shopify-section'
      },
      {
        id: 'main-cart-footer',
        section: document.getElementById('main-cart-footer').dataset.id,
        selector: '.js-contents'
      }
    ];
  }

  updateQuantity(line, quantity, name) {
    this.enableLoading(line);
    var $this=this;
    const sections = this.getSectionsToRender().map((section) => section.section);
    const sectionsUrl = window.location.pathname;

    // Dropping a paid line can strand free gifts the cart no longer earns. Those
    // removals ride along in this same request rather than being reconciled
    // afterwards, so the cart never renders — and can never be checked out — in
    // a state holding unearned freebies.
    const forfeited = Number(quantity) === 0 && window.CartFreebies
      ? window.CartFreebies.forfeitedKeysAfterRemoving(this, line)
      : [];
    const removedLine = this.querySelector(`.cart-item[data-line-index="${line}"]`);
    const removedKey = removedLine && removedLine.dataset.key;

    // Deleting the travel pouch is an explicit decline, so it is recorded here —
    // before the request goes out — rather than inferred afterwards from the cart's
    // `id` marker. That marker can be absent (a cart from before the feature, a
    // failed attribute write), and when it is, the deletion reads as "never given"
    // and the pouch is re-added immediately.
    const isPouchRemoval =
      Number(quantity) === 0 &&
      removedLine &&
      window.CartFreebies &&
      window.CartFreebies.isPouch(removedLine.dataset.varId);

    if (isPouchRemoval && window.ctDeclineGift) {
      window.ctDeclineGift();
    }

    let url = routes.cart_change_url;
    let body = JSON.stringify({ line, quantity, sections, sections_url: sectionsUrl });

    // The decline markers also ride along in the removal itself. ctDeclineGift writes
    // them in a separate request, and if this one rendered first the drawer missed
    // the "Add back" row until the next reload.
    const declinedAttributes =
      isPouchRemoval && window.ctGiftDeclinedAttributes ? window.ctGiftDeclinedAttributes() : null;

    if ((forfeited.length || declinedAttributes) && removedKey) {
      const updates = {};
      updates[removedKey] = 0;
      forfeited.forEach((key) => { updates[key] = 0; });

      url = routes.cart_update_url;
      const payload = { updates, sections, sections_url: sectionsUrl };
      if (declinedAttributes) payload.attributes = declinedAttributes;
      body = JSON.stringify(payload);
    }


    fetch(url, { ...fetchConfig(), ...{ body } })
      .then((response) => {

        return response.text();
      })
      .then((state) => {
        const parsedState = JSON.parse(state);
               console.log(parsedState);
          var total_price=parsedState.total_price;
            total_price=parseFloat(total_price/100)
          jQuery(".sr-headless-checkout").prop("disabled", true);
            // alert(total_price+" === "+parsedState.attributes.id)
                    // if(total_price >= 749  && total_price <= 1248 && parsedState.attributes.id != 47243158683970  )
                    // {
                    // // alert("cart travel");
                    //  var attr_id=parsedState.attributes.id;
                    //  // if(typeof attr_id !== "undefined" )
                    //  //      {
                    //         $.ajax({
                    //           type: 'POST',
                    //           url: '/cart/change.js',
                    //           dataType: 'json',
                    //           data: {
                    //               quantity: 0,
                    //               id: attr_id
                    //           },
                    //           success: function (data){                        
                    //             jQuery('.ct_'+attr_id).closest('.cart-item').remove();
                    //           }
                    //     })
                    //  //      //  alert("cart "+attr_id)
                    //  //        jQuery('.ct_'+attr_id).trigger('click');
                    //  //      }
                       

                      

                    //    $.ajax({
                    //           type: 'POST',
                    //           url: '/cart/update.js',
                    //           dataType: 'json',
                    //            data:{
                    //              attributes: {
                    //                    id: "47243158683970"
                    //               }
                    //            },
                    //       success: function (data){
                    //            if(parsedState.attributes.id != 47243158683970)
                    //             {
                    //              var sec_attribute = 47243158683970;
                               
                    //               $("body").append('<product-form class="product-form dev_ap" ><div class="product-form__error-message-wrapper" role="alert" hidden=""><svg aria-hidden="true" focusable="false" class="icon icon-error" viewBox="0 0 13 13"><circle cx="6.5" cy="6.50049" r="5.5" stroke="white" stroke-width="2"></circle><circle cx="6.5" cy="6.5" r="5.5" fill="#EB001B" stroke="#EB001B" stroke-width="0.7"></circle><path d="M5.87413 3.52832L5.97439 7.57216H7.02713L7.12739 3.52832H5.87413ZM6.50076 9.66091C6.88091 9.66091 7.18169 9.37267 7.18169 9.00504C7.18169 8.63742 6.88091 8.34917 6.50076 8.34917C6.12061 8.34917 5.81982 8.63742 5.81982 9.00504C5.81982 9.37267 6.12061 9.66091 6.50076 9.66091Z" fill="white"></path><path d="M5.87413 3.17832H5.51535L5.52424 3.537L5.6245 7.58083L5.63296 7.92216H5.97439H7.02713H7.36856L7.37702 7.58083L7.47728 3.537L7.48617 3.17832H7.12739H5.87413ZM6.50076 10.0109C7.06121 10.0109 7.5317 9.57872 7.5317 9.00504C7.5317 8.43137 7.06121 7.99918 6.50076 7.99918C5.94031 7.99918 5.46982 8.43137 5.46982 9.00504C5.46982 9.57872 5.94031 10.0109 6.50076 10.0109Z" fill="white" stroke="#EB001B" stroke-width="0.7"></path></svg><span class="product-form__error-message"></span></div><form method="post" action="/cart/add" id="product-form-quickadd-template--14503160479790__main" accept-charset="UTF-8" class="form" enctype="multipart/form-data" novalidate="novalidate" data-type="add-to-cart-form"><input type="hidden" name="form_type" value="product"><input type="hidden" name="utf8" value="✓"><input type="hidden" name="id" value="'+sec_attribute+'" class="product-variant-id"><div class="bold_options" ></div><div class="product-form__buttons"><button id="ProductSubmitButton-quickadd-template--14503160479790__main" type="submit" name="add" class="product-form__submit button button--full-width button--primary" aria-haspopup="dialog"><span class="dev_upsell_click">Add to cart</span><div class="loading-overlay__spinner hidden"><svg aria-hidden="true" focusable="false" class="spinner" viewBox="0 0 66 66" xmlns="http://www.w3.org/2000/svg"><circle class="path" fill="none" stroke-width="6" cx="33" cy="33" r="30"></circle></svg></div></button></div></form></product-form>');
                    //               $(document).find('.dev_upsell_click').trigger("click");
                    //              $(".dev_ap").remove();
                                  
                    //             }
                    //       }
                    //    });
                            
                     
                   
                    // }
                    // else 
                    // Gift add/removal is handled centrally by the global cart-mutation
                    // hook in ct-atc-flow.js, which already sees this /cart/change.js
                    // request. Only the unrelated promo and checkout-button side effects
                    // that happened to share this if/else chain remain here; both were
                    // reachable only below the old threshold, so that guard is kept.
                    if (total_price < 999) {
                      if (total_price <= 499) {
                        var cls = jQuery('.ct_gift_active').length;
                        var myarr = ["GCS15", "UHC15", "WLIC15", "SDCC15", "FSSG15"];
                        var removedSku = (parsedState.items_removed && parsedState.items_removed[0]) ? parsedState.items_removed[0].sku : null;
                        if (myarr.indexOf(removedSku) > -1) {
                          if (cls > 1) {
                            jQuery('.ct_main_active .ct_gift_active:first').click();
                          }
                        } else {
                          if (cls > 0) {
                            jQuery('.ct_main_active .ct_gift_active:first').click();
                          }
                        }
                      }
                      jQuery(".sr-headless-checkout").prop("disabled", false);
                    }
        
          
        
        
        //console.log(parsedState)
        const quantityElement = document.getElementById(`Quantity-${line}`) || document.getElementById(`Drawer-quantity-${line}`);
        const items = document.querySelectorAll('.cart-item');

        if (parsedState.errors) {
          if (quantityElement) quantityElement.value = quantityElement.getAttribute('value');
          this.updateLiveRegions(line, parsedState.errors);
          return;
        }

        this.classList.toggle('is-empty', parsedState.item_count === 0);
        const cartDrawerWrapper = document.querySelector('cart-drawer');
        const cartFooter = document.getElementById('main-cart-footer');

        if (cartFooter) cartFooter.classList.toggle('is-empty', parsedState.item_count === 0);
        if (cartDrawerWrapper) cartDrawerWrapper.classList.toggle('is-empty', parsedState.item_count === 0);
        console.log("co======");
         
      
        
        this.getSectionsToRender().forEach((section => {
          
          const elementToReplace =
            document.getElementById(section.id).querySelector(section.selector) || document.getElementById(section.id);
          elementToReplace.innerHTML =
            this.getSectionInnerHTML(parsedState.sections[section.section], section.selector);
        }));

        
        const updatedValue = parsedState.items[line - 1] ? parsedState.items[line - 1].quantity : undefined;
        let message = '';
        if (quantityElement && items.length === parsedState.items.length && updatedValue !== parseInt(quantityElement.value)) {
          if (typeof updatedValue === 'undefined') {
            message = window.cartStrings.error;
          } else {
            message = window.cartStrings.quantityError.replace('[quantity]', updatedValue);
          }
        }
        this.updateLiveRegions(line, message);


     
        const lineItem = document.getElementById(`CartItem-${line}`) || document.getElementById(`CartDrawer-Item-${line}`);
        if (lineItem && lineItem.querySelector(`[name="${name}"]`)) {
          cartDrawerWrapper ? trapFocus(cartDrawerWrapper, lineItem.querySelector(`[name="${name}"]`)) : lineItem.querySelector(`[name="${name}"]`).focus();
        } else if (parsedState.item_count === 0 && cartDrawerWrapper) {
          trapFocus(cartDrawerWrapper.querySelector('.drawer__inner-empty'), cartDrawerWrapper.querySelector('a'))
        } else if (document.querySelector('.cart-item') && cartDrawerWrapper) {
          trapFocus(cartDrawerWrapper, document.querySelector('.cart-item__name'))
        }
        publish(PUB_SUB_EVENTS.cartUpdate, {source: 'cart-items'});

          
           // if(total_price >= 749 && total_price <= 1298 && parsedState.attributes.id != 47243158683970)
           //  {
           //      var attr_id=parsedState.attributes.id;
           //     if(typeof attr_id !== "undefined")
           //          {
           //            $.ajax({
           //              type: 'POST',
           //              url: '/cart/change.js',
           //              dataType: 'json',
           //              data: {
           //                  quantity: 0,
           //                  id: attr_id
           //              },
           //              success: function (data){                        
           //                jQuery('.ct_'+attr_id).closest('.cart-item').remove();
           //              }
           //              })
           //            // jQuery('.ct_'+attr_id).trigger('click');
           //          }
           //  }
           //  else if(total_price >= 1299 && parsedState.attributes.id != 47243158683970)
           //  { 
           //      var attr_id=parsedState.attributes.id;
           //          if(typeof attr_id !== "undefined")
           //          {
           //            $.ajax({
           //              type: 'POST',
           //              url: '/cart/change.js',
           //              dataType: 'json',
           //              data: {
           //                  quantity: 0,
           //                  id: attr_id
           //              },
           //              success: function (data){                        
           //                jQuery('.ct_'+attr_id).closest('.cart-item').remove();
           //              }
           //              })
           //            // jQuery('.ct_'+attr_id).trigger('click');
           //          }
              
           //  }else if(total_price < 749)
           //  {
           //    if(total_price < 1)
           //    {
           //      jQuery('.ct_gift_active').trigger('click');
           //    }
           //    var attr_id=parsedState.attributes.id;
     
           //    if(typeof attr_id !== "undefined")
           //        {
           //           jQuery('.ct_'+attr_id).trigger('click');
           //        }
           //  }
            if(total_price <= 0 && total_price <= 499) {
              console.log("price==="+total_price)
                  jQuery('.ct_main_active .ct_gift_active:first').trigger("click");
                }
        
      
      
      
      }).catch(() => {
        this.querySelectorAll('.loading-overlay').forEach((overlay) => overlay.classList.add('hidden'));
        const errors = document.getElementById('cart-errors') || document.getElementById('CartDrawer-CartErrors');
        errors.textContent = window.cartStrings.error;
      })
      .finally(() => {
        // onChange shows this loader unconditionally, so always hide it. The gift's
        // own loader is owned by the global cart-mutation hook in ct-atc-flow.js.
        jQuery(".loader-main").hide()
        this.disableLoading(line);
      });
  }

  updateLiveRegions(line, message) {
    const lineItemError = document.getElementById(`Line-item-error-${line}`) || document.getElementById(`CartDrawer-LineItemError-${line}`);
    if (lineItemError) lineItemError.querySelector('.cart-item__error-text').innerHTML = message;

    this.lineItemStatusElement.setAttribute('aria-hidden', true);

    const cartStatus = document.getElementById('cart-live-region-text') || document.getElementById('CartDrawer-LiveRegionText');
    cartStatus.setAttribute('aria-hidden', false);

    setTimeout(() => {
      cartStatus.setAttribute('aria-hidden', true);
    }, 1000);
  }

  getSectionInnerHTML(html, selector) {
    
    return new DOMParser()
      .parseFromString(html, 'text/html')
      .querySelector(selector).innerHTML;
  }

  enableLoading(line) {
    if (window.CartBusy) window.CartBusy.begin();

    const mainCartItems = document.getElementById('main-cart-items') || document.getElementById('CartDrawer-CartItems');
    mainCartItems.classList.add('cart__items--disabled');

    const cartItemElements = this.querySelectorAll(`#CartItem-${line} .loading-overlay`);
    const cartDrawerItemElements = this.querySelectorAll(`#CartDrawer-Item-${line} .loading-overlay`);

    [...cartItemElements, ...cartDrawerItemElements].forEach((overlay) => overlay.classList.remove('hidden'));

    document.activeElement.blur();
    this.lineItemStatusElement.setAttribute('aria-hidden', false);
  }

  disableLoading(line) {
    if (window.CartBusy) window.CartBusy.end();

    const mainCartItems = document.getElementById('main-cart-items') || document.getElementById('CartDrawer-CartItems');
    mainCartItems.classList.remove('cart__items--disabled');

    const cartItemElements = this.querySelectorAll(`#CartItem-${line} .loading-overlay`);
    const cartDrawerItemElements = this.querySelectorAll(`#CartDrawer-Item-${line} .loading-overlay`);

    cartItemElements.forEach((overlay) => overlay.classList.add('hidden'));
    cartDrawerItemElements.forEach((overlay) => overlay.classList.add('hidden'));
  }
}

customElements.define('cart-items', CartItems);

if (!customElements.get('cart-note')) {
  customElements.define('cart-note', class CartNote extends HTMLElement {
      constructor() {
        super();

      this.addEventListener('change', debounce((event) => {
            const body = JSON.stringify({ note: event.target.value });
            fetch(`${routes.cart_update_url}`, { ...fetchConfig(), ...{ body } });
      }, ON_CHANGE_DEBOUNCE_TIMER))
      }
  });
};
